module.exports = __webpack_public_path__ + "static/media/logo.e7cf0101.svg";